// components/ProtectGuard.js
import { Navigate, Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import useAuthStore from '../../store/authStore';

const ProtectGuard = ({requireAuth = true}) => {
  const { user, isLoading, fetchUser } = useAuthStore();

  useEffect(() => {
    if (!user) {
      fetchUser();
    }
  }, [user, fetchUser]);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  if (!user && requireAuth && !isLoading) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectGuard;
